export default {"src":"/_next/static/media/ngc.42023405.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};